module.exports = __webpack_public_path__ + "img/ewm2.af2d5cb8.png";